<template>
  <div>
      <HeaderControls :myWeek='false' @filterUpdated='filterUpdate' @collapseToggleUpdated='collapseToggleUpdate' :namespace="namespace" />
      <div class="deliverable-main container-fluid">
          <SocialList :filterQuery="filterQuery" :myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate'  :namespace="namespace"/>
      </div>
  </div>
</template>
<script>
import SocialList from "./SocialList";
import HeaderControls from "../../components/common/HeaderControlsSocial";
import { mapGetters } from "vuex";

export default {
  data() {
  return {
  	namespace:"",
    filterQuery: {

      query: "",
      filterByDate: false,
      filterByDateCreated: false,
      filterByDateCompleted: false, 
      dateRange: {
        startDate: new Date(),
        endDate: new Date()
      },
      dateCreatedRange: {
        startDate: new Date(),
        endDate: new Date()
      },
      dateCompletedRange: {
        startDate: new Date(),
        endDate: new Date()
      },
      status: [],
      outlet: [],
      deliverableType: [],
      tag: [],
      department: [],
      coordinator: [],
      project: [],
    },
    expandAll: !this.isMobile()
  }
},
computed: {
  ...mapGetters(["allCustomFields", 'allUsers']),
  forceUpdateCounter() {
    return this.$store.state.deliverables.forceUpdateCounter
  },
  statuses() {
    let statusField = _.find(this.allCustomFields, { field_key: "status" });
    if (typeof statusField != "undefined") {
      let valueSet = [],
        data = JSON.parse(statusField.value_set);
      Object.keys(data).forEach(function(item) {
        valueSet.push(data[item]);
      });
      return valueSet;
    }
  }
},
components: {
  SocialList,
  HeaderControls
},
methods: {
  filterUpdate(filterQuery) {
    this.filterQuery = filterQuery
  },
  collapseToggleUpdate(expandAll) {
    this.expandAll = expandAll
  }
}
}
</script>
